const e=15,o=2e3;export{e as COUNTDOWN_MINUTES,o as STATUS_INTERVAL};
//# sourceMappingURL=config.js.map
